import type { FullOfferType } from "../context/FlightSelectionPayloadContext/FlightSelectionPayloadContext";
import type { FlightOffer } from "../context/FlightSelectionPayloadContext/FlightSelectionPayloadContextProvider";

export const mapToFlightOffer = (
  selectedFlightsKeys: string[],
  offer: FullOfferType,
): FlightOffer => {
  const flightOverview = offer.flightsOverview.find((fo) =>
    selectedFlightsKeys.every((fr) => fo.flightReferences.includes(fr)),
  );
  if (!flightOverview) throw new Error();

  const selectedFlights = [flightOverview.departureFlight];
  if (flightOverview.returnFlight) {
    selectedFlights.push(flightOverview.returnFlight);
  }

  return {
    index: offer.index,
    offerItems: offer.offerItems,
    itineraryIndex: flightOverview.itineraryIndex,
    searchResultKey: offer.searchResultKey,
    searchResultToken: offer.searchResultToken,
    flights: selectedFlights,
  };
};
